import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MyProfileService } from '@/services/my-profile/my-profile.service';
import { DocumentService } from '@/services/document/document.service';
import { Infractions } from '@/interfaces/my-profile/my-profile';
import { AuthService } from '@/auth/service/auth.service';

@Component({
  selector: 'app-infractions-view',
  templateUrl: './infractions-view.component.html',
  styleUrls: ['./infractions-view.component.css'],
})
export class InfractionsViewComponent implements OnInit {

  @Input() userRutDv: string = '';
  @Input() requestType: 'search' | '' = '';
  @Output() showForm = new EventEmitter<number>();

  infractionsLoading: boolean = true;
  infractionsError: string = '';
  infractionsData: Infractions[] = [];
  infractionsPagination: number = 3;
  shouldShowCreateNewInfraction: boolean = false;

  constructor(
    private myProfileService: MyProfileService,
    private documentService: DocumentService,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.getInfractions();
    if (this.auth.userHavePrivilege('INFRINGEMENT CREATE')) {
      this.shouldShowCreateNewInfraction = true;
    }
  }

  getInfractions() {
    this.myProfileService.getInfractions(this.userRutDv)
      .subscribe(
        (infractions) => {
          this.infractionsData = infractions.sort((a, b) => {
            const aParam = a.dateRegister.split('-').join('');
            const bParam = b.dateRegister.split('-').join('');
            if (aParam > bParam) {
              return -1;
            }
            if (aParam < bParam) {
              return 1;
            }
            return 0;
          }).sort((a, b) => {
            const aState = a.infractionState === 1 ? -1 : 1;
            const bState = b.infractionState === 1 ? -1 : 1;
            if (aState > bState) {
              return 1;
            }
            if (aState < bState) {
              return -1;
            }
            return 0;
          });

          this.infractionsLoading = false;
        },
        () => {
          this.infractionsData = [];
          this.infractionsError = 'Ha ocurrido un error al intentar obtener la información asociada a infracciones.';
          this.infractionsLoading = false;
        },
      );
  }

  downloadInfractionsPdf() {
    this.documentService.downloadDocumentFileInfringement(this.userRutDv).subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = `infractions_${this.userRutDv}`;
        a.click();
        URL.revokeObjectURL(objectUrl);
      },
    });
  }

  showMoreInfractions(showing: boolean) {
    if (showing) {
      this.infractionsPagination += 3;
    }
    else {
      this.infractionsPagination = 3;
    }

  }

  onShowForm(id: number) {
    this.showForm.emit(id);
  }
}
